import { FC } from 'react';
import { IconButton, Theme, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { ReactComponent as OxIcon } from '../../assets/icons/ox-icon.svg';

const ConnectionsLoadError: FC<
  React.PropsWithChildren<ConnectionsLoadErrorProps>
> = ({ errorMessage }) => {
  const { classes } = useStyles();

  return (
    <div className={classes.content}>
      <IconButton disabled className={classes.iconButton}>
        <OxIcon />
      </IconButton>
      <Typography variant='body2' color='textPrimary'>
        {errorMessage}
      </Typography>
    </div>
  );
};

export interface ConnectionsLoadErrorProps {
  errorMessage: string;
}

const useStyles = makeStyles()((theme: Theme) => ({
  content: {
    flexGrow: 1,
    marginTop: '20%',
    padding: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  iconButton: {
    marginRight: theme.spacing(5),
  },
}));

export default ConnectionsLoadError;
